import React, { useEffect, useState, useContext } from 'react';
import stateJSON from '../../assets/json/state.json';
import { useNavigate, Link } from 'react-router-dom';
import { CustomToolTip } from '../../components/CustomToolTip';
import { EditClient } from '../../apis';
import { SuperAdminContext } from '../../contexts';
import { TextField } from '@mui/material';

const SuperAdminEditClientInfo = () => {
	const { clients, fetchclients, fetchallusers } =
		useContext(SuperAdminContext);

	const [countryList, setCountryList] = useState([]);
	const [stateList, setStateList] = useState([]);
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [State, setState] = useState('');
	const [Country, setCountry] = useState('');
	const [Organization, setOrganization] = useState('');
	const [NoOfStaff, setNoOfStaff] = useState('');
	const [isActive, setActive] = useState(true);
	const [uuid, setUuid] = useState('');
	const [isLeadGenerationJob, setLeadGenerationJob] = useState(true);
	const [isLeadGenerationCandidate, setLeadGenerationCandidate] =
		useState(true);

	const SPECIAL_REGEX_ORG = /[`~!@#$%^&()+=_}{"':?><|/;|\]\\"["]/;

	useEffect(() => {
		setCountryList(() => {
			const usaCanada = [];
			const countries = stateJSON.filter(val => {
				if (val.country === 'United States' || val.country === 'Canada') {
					usaCanada.push(val);
					return false;
				}
				return true;
			});
			return [...usaCanada, ...countries];
		});
		let path = window.location.pathname;
		var pathUuid = path.substring(path.lastIndexOf('/') + 1, path.length);
		let client = clients?.filter(val => val.uuid === pathUuid);
		if (client[0]) {
			setCountry(client[0]?.country);
			setState(client[0]?.state);
			setActive(client[0]?.is_active);
			setLeadGenerationJob(client[0]?.is_lead_generation_job);
			setLeadGenerationCandidate(client[0]?.is_lead_generation_candidate);
			setNoOfStaff(client[0]?.noOfStaff);
			setOrganization(client[0]?.organization);
			setUuid(client[0]?.uuid);
		}
	}, [clients]);

	const createOrganization = async () => {
		if (Country === '') {
			const x = document.getElementById('countryError');
			x.style.display = 'block';
			return false;
		}
		if (State === '') {
			const x = document.getElementById('stateError');
			x.style.display = 'block';
			return false;
		}
		setLoading(true);

		const resp = await EditClient({
			country: Country,
			state: State,
			organization: Organization,
			noOfStaff: NoOfStaff,
			is_lead_generation_job: isLeadGenerationJob,
			is_lead_generation_candidate: isLeadGenerationCandidate,
			is_active: isActive,
			uuid: uuid,
		});
		if (resp.status === 200) {
			await fetchclients();
			await fetchallusers();

			navigate(-1);
		}
		if (resp.status === 400) {
			const x = document.getElementById('clientCreateError');
			x.style.display = 'block';
		}
		setLoading(false);
	};

	const renderState = country => {
		for (let i = 0; i < countryList.length; i++) {
			if (countryList[i].country === country) {
				setStateList(countryList[i].states);
			}
		}
		setState('');
	};

	const activeCheckBox = () => {
		setActive(!isActive);
	};

	const leadGenerationJobCheckBox = () => {
		setLeadGenerationJob(!isLeadGenerationJob);
	};

	const leadGenerationCandidateCheckBox = () => {
		setLeadGenerationCandidate(!isLeadGenerationCandidate);
	};

	return (
		<div className='content'>
			<div className='container-fluid'>
				<div className='card-plain'>
					<div className='card-body '>
						<div className='row'>
							<div className='col-md-12'>
								<div className='card-plain bb10'>
									<div className='row'>
										<div className='col-md-4'>
											<h3> Edit Client</h3>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className='row'>
					<div className='col-md-12 lrpad'>
						<div className='card mt_zero pad_zero'>
							<div className='client-box'>
								<div className='row pt1'>
									<div className='col-md-6  '>
										<div className='form-group'>
											<TextField
												id='standard-basic'
												label='Organization'
												variant='standard'
												value={Organization}
												onChange={evt => {
													if (
														SPECIAL_REGEX_ORG.test(evt.target.value) === false
													) {
														setOrganization(evt.target.value);
														const x = document.getElementById('orgError');
														x.style.display = 'none';
														const y =
															document.getElementById('orgErrorInvalid');
														y.style.display = 'none';
													} else {
														const x =
															document.getElementById('orgErrorInvalid');
														x.style.display = 'block';
													}
												}}
												fullWidth
											/>
											<div
												className='notes'
												id='orgError'
												style={{ display: `none` }}
											>
												Organization is required
											</div>
											<div
												className='notes'
												id='orgErrorInvalid'
												style={{ display: `none` }}
											>
												Special characters/numbers not allowed in company name
											</div>
										</div>
									</div>

									<div className='col-md-6  '>
										<label className='bmd-label-floating'>
											company Size
											<span className='sup_char'>
												<sup>*</sup>
											</span>
										</label>
										<div className='form-group'>
											<select
												className='form-control select-top'
												value={NoOfStaff}
												onChange={evt => {
													setNoOfStaff(evt.target.value);
													const x = document.getElementById('noOfStaffError');
													x.style.display = 'none';
												}}
											>
												<option value={NoOfStaff}>{NoOfStaff}</option>
												<option>1-20</option>
												<option>21-100</option>
												<option>101-500</option>
												<option>501-1000</option>
												<option>1001-5000</option>
												<option>5001-10000</option>
												<option>10000+</option>
											</select>
											<div
												className='notes'
												id='noOfStaffError'
												style={{ display: `none` }}
											>
												Please enter the staff number
											</div>
											<span className='fa fa-fw fa-angle-down field_icon eye'></span>
										</div>
									</div>

									<div className='col-md-6  '>
										<label className='label-static'>
											Country
											<span className='sup_char'>
												<sup>*</sup>
											</span>
										</label>
										<div className='form-group'>
											<select
												className='form-control select-top'
												id='selectCountry'
												name='selectCountry'
												value={Country}
												onChange={evt => {
													setCountry(evt.target.value);
													renderState(evt.target.value);
													const x = document.getElementById('countryError');
													x.style.display = 'none';
												}}
											>
												<option value={Country}>{Country}</option>
												{countryList.map(localState =>
													localState.country !== Country ? (
														<option key={localState.country}>
															{localState.country}
														</option>
													) : null
												)}
											</select>
											<span className='fa fa-fw fa-angle-down field_icon eye'></span>
											<div
												className='notes'
												id='countryError'
												style={{ display: `none` }}
											>
												Country is required
											</div>
										</div>
									</div>

									<div className='col-md-6  '>
										<label className='label-static'>
											State / Province
											<span className='sup_char'>
												<sup>*</sup>
											</span>
										</label>
										<div className='form-group'>
											<select
												className='form-control select-top'
												value={State}
												onChange={evt => {
													setState(evt.target.value);
													const x = document.getElementById('stateError');
													x.style.display = 'none';
												}}
											>
												<option value={State}>{State}</option>
												{stateList.map(localState =>
													localState !== State ? (
														<option key={localState}>{localState}</option>
													) : null
												)}
											</select>
											<div
												className='notes'
												id='stateError'
												style={{ display: `none` }}
											>
												State/Province is required
											</div>
											<span className='fa fa-fw fa-angle-down field_icon eye'></span>
										</div>
									</div>

									<div className='col-md-12'>
										<h4 className='text-secondary'>Settings</h4>

										<div className='col-md-6'>
											<table className='noborder'>
												<tbody>
													<tr>
														<td className='client-info1'>
															<b>Active</b>
															<CustomToolTip content='Determines if the client account is accessible or not' />
														</td>
														<td>
															<div
																className='material-switch'
																autoComplete='new-password'
															>
																<input
																	autoComplete='new-password'
																	id='someSwitchOptionDefault'
																	name='someSwitchOption001'
																	checked={isActive}
																	onChange={activeCheckBox}
																	type='checkbox'
																/>
																<label
																	for='someSwitchOptionDefault'
																	className='label-info'
																></label>
															</div>
														</td>
													</tr>
												</tbody>
											</table>
										</div>

										<div className='row mx-0'>
											<div className='col-md-6'>
												<table className='noborder'>
													<tbody>
														<tr>
															<td className='client-info1'>
																<b>Lead Generation For Job</b>
																<CustomToolTip content='Determines if the client account Lead Generation is active or not' />
															</td>
															<td>
																<div
																	className='material-switch'
																	autoComplete='new-password'
																>
																	<input
																		autoComplete='new-password'
																		id='someSwitchOptionDefault1'
																		name='someSwitchOption002'
																		checked={isLeadGenerationJob}
																		onChange={leadGenerationJobCheckBox}
																		type='checkbox'
																	/>
																	<label
																		for='someSwitchOptionDefault1'
																		className='label-info'
																	></label>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>

											<div className='col-md-6'>
												<table className='noborder'>
													<tbody>
														<tr>
															<td className='client-info1'>
																<b>Lead Generation for Candidate</b>
																<CustomToolTip content='Determines if the client account Lead Generation is active or not' />
															</td>
															<td>
																<div
																	className='material-switch'
																	autoComplete='new-password'
																>
																	<input
																		autoComplete='new-password'
																		id='someSwitchOptionDefault2'
																		name='someSwitchOption003'
																		checked={isLeadGenerationCandidate}
																		onChange={leadGenerationCandidateCheckBox}
																		type='checkbox'
																	/>
																	<label
																		for='someSwitchOptionDefault2'
																		className='label-info'
																	></label>
																</div>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
										</div>

										<div className='col-md-12 text-center mt3 pb2'>
											<button
												className='btn btn-primary mt2 outline-focus'
												onClick={createOrganization}
												disabled={loading}
											>
												Save
											</button>
											<Link
												to={'/super-admin/clients'}
												className='btn-plain'
											>
												Close
											</Link>
											<div
												className='notes'
												id='clientCreateError'
												style={{ display: `none` }}
											>
												Client Not Created !
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SuperAdminEditClientInfo;
